import { colors } from '../../colors';
import { applyColorAlpha } from '../utils';
const lightColors = [
    '#009EBA',
    '#007FA3',
    '#0F5980',
    '#24A859',
    '#248A70',
    '#186349',
    '#9E9600',
    '#898F37',
    '#606408',
    '#C48800',
    '#947456',
    '#994D03',
    '#D46555',
    '#A3586D',
    '#962A43',
    '#B2399F',
    '#8168A8',
    '#6C3699',
];
export const avatarLightTheme = {
    'avatar-neutral': colors.neutrals.n350,
    'avatar-secondary': applyColorAlpha(colors.neutrals.n400, 0.1),
    'avatar-secondary-icon-color': colors.neutrals.n300,
    'avatar-group-max-hint': colors.neutrals.n400,
};
lightColors.forEach((color, i) => {
    avatarLightTheme[`avatar-primary-${(i + 1).toString().padStart(2, '0')}`] = color;
});
const darkColors = [
    '#BED9FE',
    '#3FC0C1',
    '#1F9CB6',
    '#7FFED1',
    '#70CE5F',
    '#00A96E',
    '#00A96E',
    '#CBB85D',
    '#D8AC00',
    '#FEBD7F',
    '#EF8953',
    '#DA781C',
    '#F9B3C1',
    '#F086BA',
    '#FC4C6F',
    '#D4BEFE',
    '#BF9EFF',
    '#9A66FE',
];
export const avatarDarkTheme = {
    'avatar-neutral': colors.neutrals.n400,
    'avatar-secondary': applyColorAlpha(colors.neutrals.n400, 0.1),
    'avatar-secondary-icon-color': 'var(--goto-text-02)',
    'avatar-group-max-hint': colors.neutrals.n300,
};
darkColors.forEach((color, i) => {
    avatarDarkTheme[`avatar-primary-${(i + 1).toString().padStart(2, '0')}`] = color;
});
